import { BaseForm } from '@vivaldis/antd-ui'
import { useTranslation } from 'react-i18next'
import { Grid } from '../../../../../Grid'
import {
  HEALTH_RISKS_ITEMS,
  REQUIRED_VACCINATIONS_AND_TESTS_ITEMS
} from '../../../../constants/wpsFormSteps'
import { WPSItemCheckbox } from '../../../WPSItemCheckbox'

export const Step3 = () => {
  const [t] = useTranslation('web_ui')

  return (
    <>
      <BaseForm.Item label={t('work_post_sheet_form.group_2.label')}>
        <Grid columns={1} gap={0} columnGap={16} marginTop={6}>
          {REQUIRED_VACCINATIONS_AND_TESTS_ITEMS.map(name => (
            <WPSItemCheckbox key={name} name={name} />
          ))}
        </Grid>
      </BaseForm.Item>
      <BaseForm.Item label={t('work_post_sheet_form.group_3.label')}>
        <Grid columns={1} gap={0} columnGap={16} marginTop={6}>
          {HEALTH_RISKS_ITEMS.map(name => (
            <WPSItemCheckbox key={name} name={name} />
          ))}
        </Grid>
      </BaseForm.Item>
    </>
  )
}
